import { render, staticRenderFns } from "./FragmentPodcast.vue?vue&type=template&id=929ae2d2"
import script from "./FragmentPodcast.vue?vue&type=script&lang=ts"
export * from "./FragmentPodcast.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports